import React from 'react';

import styles from './ElementWithCount.scss';

interface Props {
  count?: number;
  element: React.ReactElement;
}

const ElementWithCount: React.FC<Props> = ({ count, element }) => (
  <span className={styles.title}>
    {element}
    {!!count && (
      <>
        <span className={styles.dot} />
        <span>{count}</span>
      </>
    )}
  </span>
);

export default ElementWithCount;
